"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Permissions = undefined;

var _ice = require("ice");

var _Exceptions = require("../AuthExceptions/Exceptions");

var _Permissions = require("../Permissions/Permissions");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Permissions/PermissionManager.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

const iceC_Permissions_PermissionManager_ids = ["::Ice::Object", "::Permissions::PermissionManager"];

_Permissions.Permissions.PermissionManager = class extends _ice.Ice.Object {};

_Permissions.Permissions.PermissionManagerPrx = class extends _ice.Ice.ObjectPrx {};

Slice.defineOperations(_Permissions.Permissions.PermissionManager, _Permissions.Permissions.PermissionManagerPrx, iceC_Permissions_PermissionManager_ids, 1, {
    "grant": [,,,, ["Permissions.Principal", true], [[7], [_Permissions.Permissions.PrincipalKind._helper], ["Permissions.AbstractPermission", true]],, [_Exceptions.AuthExceptions.AuthException], true, true],
    "grantAll": [,,,, ["Permissions.Principal", true], [[7], [_Permissions.Permissions.PrincipalKind._helper], ["Permissions.PermissionSeqHelper"]],, [_Exceptions.AuthExceptions.AuthException], true, true],
    "revoke": [,,,, ["Permissions.Principal", true], [[7], [_Permissions.Permissions.PrincipalKind._helper], ["Permissions.AbstractPermission", true]],, [_Exceptions.AuthExceptions.AuthException], true, true],
    "revokeAll": [,,,, ["Permissions.Principal", true], [[7], [_Permissions.Permissions.PrincipalKind._helper], ["Permissions.PermissionSeqHelper",, 1]],, [_Exceptions.AuthExceptions.AuthException],, true],
    "view": [, 2, 2,, ["Permissions.PermissionSeqHelper"], [[7], [_Permissions.Permissions.PrincipalKind._helper]],, [_Exceptions.AuthExceptions.AuthException],, true]
});

const iceC_Permissions_PermissionManagerAccessVerifier_ids = ["::Ice::Object", "::Permissions::PermissionManagerAccessVerifier"];

/**
 * Defines product-specific access to PermissionManager.
 * Must be implemented on product side.
 **/
_Permissions.Permissions.PermissionManagerAccessVerifier = class extends _ice.Ice.Object {};

_Permissions.Permissions.PermissionManagerAccessVerifierPrx = class extends _ice.Ice.ObjectPrx {};

Slice.defineOperations(_Permissions.Permissions.PermissionManagerAccessVerifier, _Permissions.Permissions.PermissionManagerAccessVerifierPrx, iceC_Permissions_PermissionManagerAccessVerifier_ids, 1, {
    "canManagePermissions": [, 2, 2,, [1], [[7], [_Permissions.Permissions.PrincipalKind._helper], ["Permissions.PermissionSeqHelper"], [7]],, [_Exceptions.AuthExceptions.AuthException], true],
    "canViewPermissions": [, 2, 2,, [1], [[7], [_Permissions.Permissions.PrincipalKind._helper], [7]],, [_Exceptions.AuthExceptions.AuthException],,]
});
exports.Permissions = _Permissions.Permissions;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/Permissions/PermissionManager.js
// module id = 316
// module chunks = 0